import { searchModels, createModel, updateModel, deleteModel, restoreModel, getModel, getRevisions, duplicateModel, replaceTags } from '../../../../redux/DefaultModelActions';

const model = 'Library';
const route = '/v1/library';

export const searchLibrary = (page, limit, search, view, args) => searchModels(model, route, page, limit, search, view, args);
export const createLibrary = (args) => createModel(model, route, args);
export const updateLibrary = (id, args) => updateModel(model, route, id, args);
export const deleteLibrary = (id) => deleteModel(model, route, id);
export const restoreLibrary = (id) => restoreModel(model, route, id);
export const getLibrary = (id) => getModel(model, route, id);
export const getLibraryRevision = (id) => getRevisions(model, route, id);
export const duplicateLibrary = (id) => duplicateModel(model, route, id);

// Tagging
export const replaceLibraryTags = (terms, contentType, contentId) => replaceTags(model, route, terms, contentType, contentId);